export const mobileMaxWidth = 768
export const maxSiteAge = 86400000 